import React from 'react';
import { Plus, LayoutGrid } from 'lucide-react';
import { useI18n } from '../../contexts/I18nContext';

interface EmptyDeckStateProps {
  onCreateNew: () => void;
}

export function EmptyDeckState({ onCreateNew }: EmptyDeckStateProps) {
  const { t } = useI18n();
  
  return (
    <div className="text-center py-12 bg-white rounded-lg shadow-md">
      <LayoutGrid className="mx-auto h-12 w-12 text-gray-400" />
      <h3 className="mt-2 text-sm font-medium text-gray-900">{t('decks_page.empty_state.title')}</h3>
      <p className="mt-1 text-sm text-gray-500">
        {t('decks_page.empty_state.description')}
      </p>
      <div className="mt-6">
        <button
          onClick={onCreateNew}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700"
        >
          <Plus className="h-4 w-4 mr-2" />
          {t('decks_page.new_deck')}
        </button>
      </div>
    </div>
  );
}